module.exports = __webpack_public_path__ + "img/35.724bb67f.jpg";